import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------fatch-order-listing--------------------------
export const getDashboardListApi = async (data) => {
  const endPoint = `/dashboard?filterType=${data}`;

  return await axios.get(endPoint, setJwtToken());
};
